import { useContext } from 'react';
import { CardChannelContext } from '@shared/components/blocks/contexts/channel';
import { API } from '@shared/types/api';
import { useGetCardDefinition } from './useGetCardDefinition';

export function useResolveCardDefinition(): (
  cardDefinitionId?: string,
) => API.CardDefinitionFragment | undefined {
  const channel = useContext(CardChannelContext);
  return useGetCardDefinition(channel);
}
